import { Avatar, Button, Menu, MenuButton, MenuButtonProps, MenuItem, MenuList, MenuPopover, MenuTrigger, MessageBar, MessageBarBody, MessageBarTitle, Theme, tokens, Tooltip, webDarkTheme, webLightTheme } from '@fluentui/react-components';
import React, { useEffect, useState } from 'react';
import Files from '../pages/FilesList/files-list.page';
import './layout.scss';
import {
    Desktop20Regular, PersonSupport20Regular, Cart20Regular, Add20Regular, ArrowUpload20Regular, SignOut24Regular, WeatherSunny24Regular, WeatherMoon24Regular, PanelLeftContract24Regular, PanelLeftExpand24Regular,
    FolderRegular, DataBarVerticalRegular, BookQuestionMarkRtlRegular, DesktopFlowRegular, SettingsRegular, DeleteRegular, FolderFilled, CircleRegular, CircleFilled, QuestionCircleRegular, QuestionCircle20Regular, SignOutRegular, Airplane20Regular, PlayCircleRegular, PlayCircle20Regular,
    PersonSubtractRegular,
    PersonSubtract20Regular,
    PaymentRegular,
    PersonSupportRegular,
    DesktopCursorRegular,
    HourglassHalfRegular,
    PeopleTeamRegular,
    ArrowTrendingSparkleRegular,
    CurrencyDollarEuroRegular,
    CartRegular,
    CopyRegular,
    BookQuestionMarkRegular,
    BookInformationRegular,
    AppGenericRegular,
    InfoRegular
} from '@fluentui/react-icons';
import { AuthenticatedTemplate, useIsAuthenticated, useMsal } from '@azure/msal-react';
import { FileTypeIcon } from '../files/file-type-icon/file-type-icon.component';
import logo from '../assets/dashboard-logo.png';
import DwsimLogo from "../assets/filetype-icons/dwsim.png";
import siderbarLogo from '../assets/sidebar-logo.png';
import { SidebarMenu } from './sidebar-menu/sidebar-menu';
import { generalSettings, settings, stripeSettings } from '../App';
import { IFrameModal } from '../components/iframe-modal/iframe-modal.components';
import { processServerError } from '../utils/helpers/error.helper';
import { getImpersonateUserClient, getQuestionnairesClient, getStripeCustomersClient, getTourClient, getUsersClient } from '../services/dashboard.service';
import { PricingDialogType, RegistrationConfirmationPostModel, UserResponseModel } from '../swagger-clients/s365-dashboard-v2-api-clients.service';
import { TourGuideModal } from '../tour-guide/tour-guide.modal';
import { DwsimProLicenseCheckerModal } from '../components/dwsim-pro-license-checker-modal/dwsim-pro-license-checker-modal.component';
import DwsimProIcon from "../assets/images/DWSIM-Pro-Icon.png";
import { toast } from 'react-toastify';
import { ContactFormModal } from '../components/contact-form-modal/contact-form-modal.component';
import { ImpersonateUserModal } from '../auth/impersonate-user/impersonate-user-modal.component';
import ImpersonateUserService, { ImpersonateUserData } from '../services/impersonate-user.service';
import { Link, Outlet, useNavigate, useSearchParams } from 'react-router-dom';
import { StripePricingTableDialog } from '../components/stripe-pricing-table-dialog';
import CountdownTimer from '../components/countdown-timer/countdown-timer.component';
import { ConfirmEmail } from '../pages/confirm-email/confirm-email.component';
import { useDwsimProLicense } from '../contexts/DwsimProLicenseContext';
import { InformationDialog } from '../components/information-dialog/information-dialog.component';
import { CopyToClipboard } from '../components/copy-to-clipboard-icon/copy-to-clipboard-icon.component';
import { LoginQuestionnaireModal } from '../components/login-questionnaire-modal/login-questionnaire-modal.component';
import { FaqModal } from '../components/faq-modal/faq-modal.component';
import { SocialIntentsChat } from '../components/social-intents-chat/social-intents-chat.component';
import { PurchaseOrderFormDialog } from '../components/purchase-order-form-dialog/purchase-order-form-dialog';
declare const SI_API: any;

type LayoutProps = {
    children?: JSX.Element | JSX.Element[],
    eulaAccepted?: boolean,
    currentTheme: Theme,
    onChangeTheme: (theme: Theme, isDark: boolean) => void
}

export const Layout: React.FC<LayoutProps> = (props) => {
    const { instance } = useMsal();
    const [sidebarShrinked, setSidebarShrinked] = useState(!!parseInt(window.localStorage.getItem('sidebar-shrinked')));

    const [showSupportModal, setShowSupportModal] = React.useState<boolean>(false);
    const [showTourGuideModal, setShowTourGuideModal] = React.useState<boolean>(false);
    const [showImpersonateUserModal, setShowImpersonateUserModal] = React.useState<boolean>(false);
    const [skipTourIntro, setSkipTourIntro] = React.useState<boolean>(false);
    const [canImpersonateUser, setCanImpersonateUser] = React.useState<boolean>(false);
    const [isImpersonatingUser, setIsImpersonatingUser] = React.useState<boolean>(false);
    const [showSupportDwsimProDialog, setShowSupportDwsimProDialog] = React.useState<boolean>(false);
    const [showFlowsheetCollaborationDialog, setShowFlowsheetCollaborationDialog] = React.useState<boolean>(false);
    const [impersonatedUser, setImpersonatedUser] = React.useState<ImpersonateUserData>();
    const [showUnlimitedDwsimProDialog, setShowUnlimitedDwsimProDialog] = React.useState<boolean>(false);
    const [showTeamDwsimProDialog, setShowTeamDwsimProDialog] = React.useState<boolean>(false);
    const [showHourlyDwsimProDialog, setShowHourlyDwsimProDialog] = React.useState<boolean>(false);
    const [showCopilotDialog, setShowCopilotDialog] = React.useState<boolean>(false);
    const [user, setUser] = React.useState<UserResponseModel>();
    const [confirmEmailExpiryDate, setConfirmEmailExpiryDate] = React.useState<Date>();
    const [showDwsimProUserLicenseCheckerModal, setShowDwsimPropUserLicenseCheckerModal] = React.useState<boolean>(false);
    const [showConfirmEmailWarning, setShowConfirmEmailWarning] = React.useState<boolean>(false);
    const [confirmationToken, setConfirmationToken] = React.useState<string>();
    const [searchParams, setSearchParams] = useSearchParams();
    const [allowUnregisteredAccessToHourly, setAllowUnregisteredAccessToHourly] = React.useState<boolean>(false);
    const account = instance.getActiveAccount();
    const { isValidLicense: hasDwsimProLicense } = useDwsimProLicense();
    const isAuthenticated = useIsAuthenticated();
    const [showConfirmationMailSentModal, setShowConfirmationMailSentModal] = React.useState<boolean>(false);
    const [showLoginQuestionnaire, setShowLoginQuestionnaire] = React.useState<boolean>(false);
    const [showFaqsModal, setShowFaqsModal] = React.useState<boolean>(false);
    const [isReadyToOrder, setIsReadyToOrder] = React.useState<boolean>(false);
    const [showPurchaseOrderFormDialog, setShowPurchaseOrderFormDialog] = React.useState<boolean>(false);

    const navigate = useNavigate();
    React.useEffect(() => {

        const confToken = searchParams.get("confirmationToken");
        if (!!confToken) {
            setConfirmationToken(confToken);
        }
        const showHourlyPricingAttrValue = searchParams.get("showHourlyPricing");
        if (!!showHourlyPricingAttrValue) {
            setAllowUnregisteredAccessToHourly(true);
            setShowHourlyDwsimProDialog(true);
        }


    }, []);

    React.useEffect(() => {
        if (isAuthenticated) {
            getUser();
            setIsImpersonatingUser(ImpersonateUserService.IsImpersonatingUser());
            setImpersonatedUser(ImpersonateUserService.UserData);
            checkIfUserCanImpersonateOtherUsers();
            getIsReadyToOrderStatus();
        }
    }, [isAuthenticated]);

    // React.useEffect(() => {
    //     if (isReadyToOrder && !!user) {
    //         const script = document.createElement("script");

    //         script.src = "https://www.socialintents.com/api/chat/socialintents.1.4.js#2c9fa6c392887e4f01928a03da2f0091";
    //         script.async = true;
    //         script.onload = () => {
    //             if (typeof SI_API !== "undefined") {
    //                 SI_API.setChatInfo(user.displayName, user.email, undefined, undefined);
    //             }
    //         };
    //         document.body.appendChild(script);
    //     }
    // }, [isReadyToOrder, user]);

    React.useEffect(() => {
        if (!!props.eulaAccepted && isAuthenticated) {
            checkIfLoginQuestionnaireShouldBeShown();
        }

    }, [props.eulaAccepted, isAuthenticated]);
    const getUser = async () => {
        try {
            if (!account) {
                return;
            }
            const client = getUsersClient();
            const userResp = await client.getUser(account.localAccountId);
            setUser(userResp);

        } catch (error) {
            processServerError(error, undefined, "An error occurred while getting user info.");
        }
    }

    const getIsReadyToOrderStatus = async () => {
        try {
            const client = getUsersClient();
            const readyToOrderResp = await client.getReadyToOrderStatus();
            if (readyToOrderResp?.isReadyToOrder ?? false) {
                setIsReadyToOrder(true);
            }

        } catch (error) {
            processServerError(error, undefined, "An error occurred while getting ready to order status.", false);
        }
    }

    const checkIfUserCanImpersonateOtherUsers = async () => {
        try {
            const client = getImpersonateUserClient();
            const canImpersonateResp = await client.canImpersonateUser();
            setCanImpersonateUser(!!canImpersonateResp?.canImpersonateUser);

        } catch (error) {
            processServerError(error, undefined, "An error occurred while checking if user can impersonate other users.", false);
        }

    }

    const checkIfLoginQuestionnaireShouldBeShown = async () => {
        try {
            const client = getQuestionnairesClient();
            const resp = await client.shouldShowLoginQuestionnaire();
            if (resp?.shouldShow ?? false) {
                setShowLoginQuestionnaire(true);
            }

        } catch (error) {
            processServerError(error, undefined, "An error occurred while getting information should user be shown questionnaire.", false)
        }
    }

    const onResendConfirmationEmailClick = async () => {
        try {
            const client = getUsersClient();
            const model = new RegistrationConfirmationPostModel({ email: user.email });
            await client.resendEmailConfirmation(model);
            setShowConfirmationMailSentModal(true);

        } catch (error) {
            processServerError(error, undefined, "An error occurred while resending confirmation email.");
        }
    }

    const onBillingPortalLinkClick = async () => {
        try {
            const client = getStripeCustomersClient();
            const billingUrlResp = await client.getBillingPortalUrl();
            if (!!billingUrlResp?.url) {
                window.open(billingUrlResp.url, "_blank")
            }
        } catch (error) {
            processServerError(error, undefined, "An error occurred while getting Stripe Billing Portal URL.");
        }
    }

    const handleLogout = () => {
        instance.logoutRedirect();

    };

    const toggleSidebar = () => {
        let newValue = !sidebarShrinked;
        window.localStorage.setItem('sidebar-shrinked', newValue ? '1' : '0');
        setSidebarShrinked(newValue);
    };

    return (
        <div className='wrapper'>
            {!confirmationToken && <ConfirmEmail onConfirmEmailStatusChange={(isConfirmed, expiryDate) => {
                setShowConfirmEmailWarning(!isConfirmed); setConfirmEmailExpiryDate(expiryDate);
            }} />}
          {/*  <SocialIntentsChat isReadyToOrder={isReadyToOrder} user={user} />*/}
            <div className='top-bar'>
                <div className='top-bar__sidebar'>
                    <Link to="/" className='top-bar__logo-wrapper'><img src={siderbarLogo} alt='Simulate 365 Dashboard' className='top-bar__logo' /></Link>
                    {generalSettings && generalSettings.environment.toLowerCase() !== "production" &&
                        <span style={{
                            textTransform: "uppercase", letterSpacing: "4px", fontWeight: "bold",
                            color: "red", fontSize: "14px"
                        }}>{generalSettings.environment}</span>
                    }
                </div>
                <div className='top-bar__content'>
                    <div className='top-bar__content__left' >
                        {!confirmationToken && showConfirmEmailWarning && !!confirmEmailExpiryDate &&
                            <MessageBar key={"warning"} intent={'warning'} style={{ backgroundColor: tokens.colorStatusWarningBackground2, margin: "5px" }}>
                                <MessageBarBody style={{ lineHeight: "1rem" }}>
                                    <div style={{ display: "flex", flexDirection: "column", alignItems: 'center', justifyContent: 'center' }}>
                                        {confirmEmailExpiryDate > new Date() ?
                                    /* IF */ <span>Account not confirmed. In <CountdownTimer expiryDate={confirmEmailExpiryDate} hideSeconds /> your account will be blocked.</span>
                                    /* ELSE */ : <span>Account not confirmed.</span>
                                        }
                                        <small style={{ lineHeight: "1rem" }}>See email for your account confirmation link.
                                            {" "}<a href="#" onClick={(ev) => { ev.preventDefault(); onResendConfirmationEmailClick() }}>Resend</a> confirmation link.</small>
                                    </div>
                                </MessageBarBody>
                            </MessageBar>
                        }
                    </div>


                    <div className='top-bar__content__right'>


                        {isImpersonatingUser &&
                            <div style={{ display: "flex" }}>
                                <div style={{ display: "flex", flexDirection: "column", pointerEvents: "none", padding: "3px" }}>
                                    <span><b>Impersonating user</b></span>
                                    <span>{impersonatedUser?.displayName} ({impersonatedUser?.userPrincipalName})</span>
                                </div>
                                <div>

                                </div>
                                <div className='hover-background' style={{ display: "flex" }}>
                                    <Button appearance='transparent'
                                        className='hover-background'
                                        icon={<PersonSubtract20Regular />}
                                        onClick={() => { ImpersonateUserService.stopImpersonating(); }} ></Button>

                                </div>
                            </div>
                        }


                        <ul className='top-bar__menu' style={{ paddingInlineStart: "0px" }}>

                            {!isImpersonatingUser && canImpersonateUser && <li className='top-bar__menu-item-wrapper'>
                                <a href='#' onClick={(ev) => { ev.preventDefault(); setShowImpersonateUserModal(true); }} target='_blank' className='top-bar__menu-item'>
                                    <InfoRegular style={{ marginRight: 'var(--spacingVerticalXS)' }} />System info
                                </a>
                            </li>}


                            {/* <li className='top-bar__menu-item-wrapper'> <Button appearance='transparent' className='top-bar__menu-item' style={{ fontWeight: 400 }} onClick={() => {
        setSkipTourIntro(true);
        setShowTourGuideModal(true)
    }}>
        <PlayCircle20Regular style={{ marginRight: 'var(--spacingVerticalXS)' }} /> Virtual Tour
    </Button>
    </li> */}
                        </ul>

                        <ul id="headbar_list" className='top-bar__menu' style={{ paddingInlineStart: "0px" }}>

                            <li className='top-bar__menu-item-wrapper'> <a href='#' onClick={(ev) => { ev.preventDefault(); setShowDwsimPropUserLicenseCheckerModal(true); }} className='top-bar__menu-item'>
                                <img src={DwsimProIcon} style={{ marginRight: 'var(--spacingHorizontalSNudge)' }} />Open DWSIM Pro
                            </a>
                            </li>

                            {/* <li className='top-bar__menu-item-wrapper'> <a href='#' onClick={(ev) => { ev.preventDefault(); setShowHourlyDwsimProDialog(true); }} className='top-bar__menu-item'>
                                <Cart20Regular style={{ marginRight: 'var(--spacingVerticalXS)' }} />Hourly DWSIM Pro
                            </a>
                            </li>
                            <li className='top-bar__menu-item-wrapper'> <a href='#' onClick={(ev) => { ev.preventDefault(); setShowTeamDwsimProDialog(true); }} className='top-bar__menu-item'>
                                <Cart20Regular style={{ marginRight: 'var(--spacingVerticalXS)' }} />Team DWSIM Pro
                            </a>
                            </li>
                            <li className='top-bar__menu-item-wrapper'> <a href='#' onClick={(ev) => { ev.preventDefault(); setShowUnlimitedDwsimProDialog(true); }} className='top-bar__menu-item'>
                                <Cart20Regular style={{ marginRight: 'var(--spacingVerticalXS)' }} />Unlimited DWSIM Pro
                            </a>
                            </li> */}
                            <Menu positioning={"below-end"}>
                                <MenuTrigger disableButtonEnhancement>
                                    <MenuButton appearance='transparent' icon={<CartRegular />}>Pricing</MenuButton>
                                </MenuTrigger>

                                <MenuPopover>
                                    <MenuList>
                                        <MenuItem icon={<HourglassHalfRegular />} onClick={() => { setShowHourlyDwsimProDialog(true); }}>DWSIM Pro Hourly</MenuItem>
                                        <MenuItem icon={<PeopleTeamRegular />} onClick={() => { setShowTeamDwsimProDialog(true); }}>DWSIM Pro Team</MenuItem>
                                        <MenuItem icon={<ArrowTrendingSparkleRegular />} onClick={() => { setShowUnlimitedDwsimProDialog(true); }}>DWSIM Pro Unlimited</MenuItem>
                                        <MenuItem icon={<img width={20} height={20} src={DwsimLogo}></img>} onClick={() => { setShowSupportDwsimProDialog(true); }}>DWSIM Private Support</MenuItem>
                                        {generalSettings && generalSettings.environment.toLowerCase() !== "production" &&
                                            <MenuItem icon={<img width={20} height={20} src={DwsimLogo}></img>}
                                                onClick={() => { setShowFlowsheetCollaborationDialog(true); }}>Flowsheet Collaboration</MenuItem>
                                        }
                                        {generalSettings && generalSettings.environment.toLowerCase() !== "production" &&
                                            <MenuItem icon={<img width={20} height={20} src={DwsimLogo}></img>}
                                                onClick={() => { setShowCopilotDialog(true); }}>Flowsheet Copilot</MenuItem>
                                        }
                                        {generalSettings && generalSettings.environment.toLowerCase() !== "production" &&
                                            <MenuItem icon={<img width={20} height={20} src={DwsimLogo}></img>}
                                                onClick={() => { setShowPurchaseOrderFormDialog(true); }}>Purchase Order Form</MenuItem>
                                        }
                                        <MenuItem icon={<BookQuestionMarkRegular />} onClick={() => { setShowFaqsModal(true) }}>Subscriptions FAQs</MenuItem>

                                    </MenuList>
                                </MenuPopover>
                            </Menu>

                            <li className='top-bar__menu-item-wrapper'><a href='#' onClick={(ev) => { ev.preventDefault(); setShowSupportModal(true); }} target='_blank' className='top-bar__menu-item'>
                                <PersonSupport20Regular style={{ marginRight: 'var(--spacingVerticalXS)' }} />Contact support
                            </a>
                            </li>


                        </ul>

                        <AuthenticatedTemplate>
                            <ul className='top-bar__menu' style={{ paddingInlineStart: "0px" }}>
                                <li className='top-bar__menu-item-wrapper'>
                                    <Button appearance='transparent'
                                        icon={props.currentTheme == webDarkTheme ?
                                            <WeatherSunny24Regular style={{ color: "var(--colorNeutralForeground1)" }} />
                                            : <WeatherMoon24Regular style={{ color: "var(--colorNeutralForeground1)" }} />}
                                        onClick={() => {
                                            if (props.currentTheme == webLightTheme) {
                                                props.onChangeTheme(webDarkTheme, true);
                                            } else {
                                                props.onChangeTheme(webLightTheme, false);
                                            }

                                        }} />
                                </li>
                                <li className='top-bar__menu-item-wrapper top-bar__menu-item-wrapper--user-menu'>
                                    <Menu positioning="below-end">
                                        <MenuTrigger>
                                            {(triggerProps: MenuButtonProps) =>
                                                <MenuButton
                                                    appearance='transparent'
                                                    style={{ paddingLeft: 0, paddingRight: 0, minWidth: "40px", color: 'var(--colorNeutralForeground1)' }}
                                                    {...triggerProps}> <Avatar name={account?.name} color="blue" /></MenuButton>}
                                        </MenuTrigger>

                                        {user && <MenuPopover>
                                            <MenuList>
                                                <MenuItem disabled className='menu-item-readonly'>
                                                    <div style={{ display: "flex", flexDirection: "row" }}>
                                                        <div style={{ display: "flex", flexDirection: "column" }}>
                                                            <span style={{ fontWeight: "bold" }}> {user?.displayName}</span>
                                                            <span style={{ fontSize: "10px", lineHeight: "10px" }}>{user?.userPrincipalName}</span>
                                                        </div>
                                                        <CopyToClipboard content={user?.userPrincipalName} tooltip='Copy username' />
                                                    </div>

                                                </MenuItem>
                                                <MenuItem>
                                                    <Tooltip content="Monitor and understand your DWSIM Pro usage" relationship='description' withArrow positioning='before'>
                                                        <Button appearance='transparent' onClick={() => { navigate("/dwsim-pro-usage") }} style={{ padding: 0 }} icon={<DesktopCursorRegular />}>
                                                            DWSIM Pro usage
                                                        </Button>
                                                    </Tooltip>
                                                </MenuItem>
                                                <MenuItem onClick={() => onBillingPortalLinkClick()}>
                                                    <Tooltip content="View, change or cancel your subscription" relationship='description' withArrow positioning='before'>
                                                        <Button appearance='transparent' style={{ padding: 0 }} icon={<PaymentRegular />}> Customer Billing Portal</Button>
                                                    </Tooltip>
                                                </MenuItem>

                                                <MenuItem onClick={() => window.open("https://support.capital-gain.eu/", "_blank")}>
                                                    <Tooltip content={<span>Log in with your email <b style={{ whiteSpace: 'nowrap' }}>{user?.email}</b></span>} relationship='description' withArrow positioning='before'>
                                                        <Button appearance='transparent' style={{ padding: 0 }} icon={<PersonSupportRegular />}> Customer Support Portal</Button>
                                                    </Tooltip>
                                                </MenuItem>

                                                <MenuItem>
                                                    <Button appearance='transparent' style={{ padding: 0, justifyContent: "start" }} icon={<SignOutRegular />} onClick={handleLogout}>Logout</Button></MenuItem>
                                            </MenuList>
                                        </MenuPopover>}
                                    </Menu>
                                </li>
                            </ul>
                        </AuthenticatedTemplate>




                    </div>
                </div>




            </div>
            <div className='body'>
                <div className={'sidebar ' + (sidebarShrinked ? 'sidebar--schrinked' : '')}>
                    {sidebarShrinked ?
                        <PanelLeftExpand24Regular className='sidebar__expand-button' onClick={() => toggleSidebar()} />
                        : <PanelLeftContract24Regular className='sidebar__expand-button' onClick={() => toggleSidebar()} />
                    }
                    <SidebarMenu shrinked={sidebarShrinked} onExpand={() => setSidebarShrinked(false)} />
                </div>
                <div className='body__content'>
                    <Outlet />
                </div>
            </div>
            <div className='footer'></div>


            {showTourGuideModal && <TourGuideModal isOpened={true} skipIntro={skipTourIntro} onClose={() => { setShowTourGuideModal(false) }} />}

            {showDwsimProUserLicenseCheckerModal &&
                <DwsimProLicenseCheckerModal
                    isOpened={true}
                    onClose={() => { setShowDwsimPropUserLicenseCheckerModal(false) }} />}

            {showSupportModal && <ContactFormModal
                onHide={() => { setShowSupportModal(false); }}
                onSuccess={() => {
                    setShowSupportModal(false);
                    toast.success("Successfully sent support ticket.");
                }} />}
            {showImpersonateUserModal &&
                <ImpersonateUserModal
                    isOpened={showImpersonateUserModal}
                    onClose={() => { setShowImpersonateUserModal(false) }}
                    onSuccess={() => { setShowImpersonateUserModal(false); window.location.replace("/"); }}
                />}

            {showUnlimitedDwsimProDialog && <StripePricingTableDialog
                title="DWSIM Pro Unlimited"
                dialogType={PricingDialogType.Unlimited}
                contentHeight="474px"
                minDialogWidth="80vw"
                minDialogHeight="70vh"
                stripePricingTableId={stripeSettings.unlimitedDwsimProPricingTableId}
                stripePricingTableKey={stripeSettings.unlimitedDwsimProPricingTableKey}
                isOpened onClose={() => { setShowUnlimitedDwsimProDialog(false) }} />}

            {showTeamDwsimProDialog && <StripePricingTableDialog
                title="DWSIM Pro Team"
                dialogType={PricingDialogType.Team}
                contentHeight="474px"
                minDialogWidth="80vw"
                minDialogHeight="70vh"
                stripePricingTableId={stripeSettings.teamDwsimProPricingTableId}
                stripePricingTableKey={stripeSettings.teamDwsimProPricingTableKey}
                isOpened onClose={() => { setShowTeamDwsimProDialog(false) }} />}

            {showHourlyDwsimProDialog && <StripePricingTableDialog
                dialogType={PricingDialogType.Hourly}
                contentHeight="500px"
                title="DWSIM Pro Hourly"
                minDialogWidth={"800px"}
                allowUnregisteredAccess={allowUnregisteredAccessToHourly}
                stripePricingTableId={stripeSettings.hourlyDwsimProPricingTableId}
                stripePricingTableKey={stripeSettings.hourlyDwsimProPricingTableKey}
                isOpened onClose={() => { setShowHourlyDwsimProDialog(false) }} />}

            {showFlowsheetCollaborationDialog && <StripePricingTableDialog
                dialogType={PricingDialogType.FlowsheetCollaboration}
                contentHeight="500px"
                title="Flowsheet Collaboration"
                minDialogWidth={"800px"}
                stripePricingTableId={stripeSettings.collaborationPricingTableId}
                stripePricingTableKey={stripeSettings.collaborationPricingTableKey}
                isOpened onClose={() => { setShowFlowsheetCollaborationDialog(false) }} />}



            {showSupportDwsimProDialog && <StripePricingTableDialog
                dialogType={PricingDialogType.Support}
                contentHeight="500px"
                title="DWSIM Private Support"
                minDialogWidth={"800px"}
                stripePricingTableId={stripeSettings.supportPricingTableId}
                stripePricingTableKey={stripeSettings.supportPricingTableKey}
                isOpened onClose={() => { setShowSupportDwsimProDialog(false) }} />}

            {showCopilotDialog && <StripePricingTableDialog
                dialogType={PricingDialogType.FlowsheetCopilot}
                contentHeight="500px"
                title="Flowsheet Copilot"
                minDialogWidth={"800px"}
                stripePricingTableId={stripeSettings.copilotPricingTableId}
                stripePricingTableKey={stripeSettings.copilotPricingTableKey}
                isOpened onClose={() => { setShowCopilotDialog(false) }} />}

                {showPurchaseOrderFormDialog && <PurchaseOrderFormDialog
                    isOpened
                    onClose={() => { setShowPurchaseOrderFormDialog(false); }}
                />}

            {showConfirmationMailSentModal &&
                <InformationDialog
                    title='Confirmation mail sent'
                    isOpened
                    subText={<div style={{ textAlign: "center" }}>Confirmation email sent to <b>{user?.email}</b></div>}
                    onClose={() => { setShowConfirmationMailSentModal(false); }}
                    cancelLabel='Close'
                    hideCloseButton
                />}

            {showLoginQuestionnaire &&
                <LoginQuestionnaireModal
                    isOpened
                    onClose={() => { setShowLoginQuestionnaire(false); }}
                />}

            {showFaqsModal && <FaqModal isOpened onClose={() => { setShowFaqsModal(false); }} />}
        </div>
    );
}

export default Layout;